/**
 * @arg {unknown} value
 * @returns {string}
 */
function stringifySignupErrorCause(value) {
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value.map(String).join(" ");

  try {
    return JSON.stringify(value) ?? String(value);
  } catch (_error) {
    return String(value);
  }
}

/**
 * @arg {any} data
 * @returns {string[]}
 */
export function getSignupValidationErrorFields(data) {
  const errors = data?.json?.error?.errors;
  if (errors == null || typeof errors !== "object" || Array.isArray(errors)) {
    return [];
  }

  return Object.keys(errors).map((field) =>
    field.toLowerCase().replace(/[．.]/g, "."),
  );
}

/**
 * @arg {any} data
 * @returns {boolean}
 */
export function isActionableSignupValidationError(data) {
  return (
    data?.statusCode === 400 && getSignupValidationErrorFields(data).length > 0
  );
}

/**
 * @arg {any} data
 * @returns {Error}
 */
export function createSignupValidationError(data) {
  const cause = stringifySignupErrorCause(
    data?.json?.error?.errors ?? data?.json,
  );
  return new Error("Signup validation failed", { cause });
}

/**
 * @arg {any} data
 * @returns {Error}
 */
export function createSignupResponseError(data) {
  const responseError = data?.json?.error;
  const message =
    typeof responseError?.message === "string" && responseError.message
      ? responseError.message
      : `Signup request failed with status ${data?.statusCode ?? "unknown"}`;
  const cause = stringifySignupErrorCause(
    responseError?.errors ?? responseError ?? data?.json ?? data,
  );

  return new Error(message, { cause });
}
